import { Component, OnInit,ViewChild,HostListener } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Http, Response,Headers } from '@angular/http';
import { HelperService } from '../helper.service';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { HttpClient } from '@angular/common/http';
import {CookieService} from 'angular2-cookie/core';
import {MatProgressBarModule} from '@angular/material';


@Component({
  selector: 'app-vedio',
  templateUrl: './vedio.component.html',
  styleUrls: ['./vedio.component.css'],
    providers: [HelperService] 
})
export class VedioComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
 @ViewChild("fileInput") fileInput;
 @ViewChild('vedioUploadForm') vedioUploadForm;
  
  progress$;
  progress = 0;
  percentage = 0;
  progressObserver;
  circleloading = false;
  notifcatonloading = false;
  loading = false;

 topic_id=0;
 datas:any;
 path='';
 video_id=0;
 is_encrypted=0;
 show_video=false;
 loader=false;
 status;
 user_permissions:any=[];
 chapter_id;
  syllabus_id;
  gradeid;
  subjectid;
  subject_id;
  subjectgradeid;
  syllabusname;
  gradename;
  subjectname;
  chaptername;
  topicname;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private http: Http,private helper:HelperService,private activatedRouter:ActivatedRoute,private router:Router,private snackbar: MatSnackBar,private httpClient: HttpClient,private cookie:CookieService) {
    this.activatedRouter.params.subscribe((params: Params) => {
      this.topic_id = params['topic'];
       this.status = params['status'];
       this.chapter_id = params['chap'];
      this.syllabus_id = params['syllabusid'];
      this.gradeid = params['gradeid'];
      //alert(this.gradeid);
      this.subjectid = params['subject_id'];
      this.subject_id = params['sub'];
      this.subjectgradeid = params['subjectgradeid'];
    });
   if(this.status==1){
     this.snackbar.open('Video uploaded successfully', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
   }

   }

  ngOnInit() {
    this.http.get(this.helper.base_url+'http/get/video/'+this.topic_id,{ headers: this.headers })
  
    .subscribe(data => {
      this.show_video=true;
      this.datas = JSON.parse(data['_body']).data[0];
      this.path=this.datas.path;
      this.video_id=this.datas.id;
      this.is_encrypted=this.datas.is_encrypted;
          
    });
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    this.http.get(this.helper.base_url+'http/get/syllabus/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body);
          this.syllabusname = body.data[0].name;
          //console.log(this.syllabusname);
          //alert(this.syllabusname);
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
    this.http.get(this.helper.base_url+'http/get/gradedetails/'+this.subjectid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.gradename = body.data[0].name;
        //alert(this.gradename);
        //console.log(this.gradename);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/subjectsdetails/'+this.gradeid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.subjectname = body.data[0].name;
        //alert(this.subjectname);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/chapter/'+this.chapter_id,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.chaptername = body.data[0].name;
        //console.log(this.chaptername);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/topicdetail/'+this.topic_id,{ headers: this.headers })
  .subscribe(
     
    (data) => {
      let body = JSON.parse(data['_body']);
      //console.log(body);
      this.topicname = body.data[0].name;
      //console.log(this.chaptername);
      //alert(this.syllabusname);
      // this.refresh();
    }, //For Success Response
    err => {console.error(err)} //For Error Response
);
  }


  public add_form(addForm: NgForm)
  {
    this.loading = true;
    
    let body = new FormData();

    let xhr = new XMLHttpRequest();

    let fi = this.fileInput.nativeElement;
    body.append('file', fi.files[0]);

    xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              this.refresh();
            } else {
                //observer.error(xhr.response);
                this.circleloading = false;
            }
        }
    };

    xhr.upload.onprogress = (event) => { 
        this.circleloading = true;
        this.progress = Math.round(event.loaded / event.total * 100);
        //this.progressObserver.next(this.progress);

        if(this.progress == 100)
        {
          this.notifcatonloading = true;
        }
    };

    xhr.open('POST', this.helper.base_url+'http/vedio/upload/'+this.topic_id, true);
    xhr.send(body);
  }


 submit_click(vedioUploadForm: NgForm){
   // this.loader=true;
    
 //  this.vedioUploadForm.nativeElement.submit();

  
 }

 processVideo() {
     
     window.open(
      this.helper.base_url+'http/vedio/encryptVideoDownload/'+this.video_id,
      '_blank'
    );

  }

 refresh(val=false){
   
  this.snackbar.open('Video uploaded successfully', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["vedio/"+this.topic_id+"/0",this.chapter_id,this.syllabus_id,this.subjectid,this.gradeid,this.subject_id,this.subjectgradeid]));
      
 }
 backbtn(){

 window.history.back();
}

}



// WEBPACK FOOTER //
// ./src/app/vedio/vedio.component.ts